import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings } from 'lucide-react';
import Alert from '../common/Alert.js';
import roleService from '../../services/RoleService.js';
import { FormLayout, FormField } from '../common/index.js';

const AddRole = () => {
  const [formData, setFormData] = useState({
    role_name: '',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await roleService.create(formData);
      Alert.success('Role created successfully!');
      setTimeout(() => navigate('/roles'), 1500);
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to create role');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormLayout
      title="Add New Role"
      icon={Settings}
      onSubmit={handleSubmit}
      submitLabel={loading ? 'Creating...' : 'Create Role'}
      loading={loading}
      onCancel={() => navigate('/roles')}
      maxWidth="max-w-7xl"
    >
      <div>
        <h3 className="text-base font-semibold text-tertiary mb-4 pb-2 border-b border-gray-100">
          Role Information
        </h3>
        <FormField label="Role Name" required className="sm:w-1/3">
          <input
            type="text"
            name="role_name"
            value={formData.role_name}
            onChange={handleChange}
            placeholder="Enter role name (e.g., Manager, Supervisor)"
            className="input-clean"
            required
          />
          <p className="text-xs text-gray-600 mt-2">Enter a descriptive name for the role</p>
        </FormField>
      </div>
    </FormLayout>
  );
};

export default AddRole;
